/*
 * @Description: 首页 store
 * @Author: Duan Yu (949267840@qq.com)
 * @Date: 2019-08-01 19:28:14
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-02-22 14:30:08
 */
import {
// getDeviceCount,
} from './service'

const state = {
  // 右侧切换 toggle 的激活项
  // rightToggleBarActive: [...RIGHT_TOGGLE][0][0],
}

const mutations = {
  setState (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  // async getDeviceCount({ commit }) {
  //   const res = await getDeviceCount()

  //   if (res.code === 'success') {
  //     commit('setState', { deviceCount: res.data })
  //   }

  //   return res
  // },
  // async getLeftList({ commit }, payload) {
  //   const res = await getLeftList(payload)

  //   if (res.code === 'success') {
  //     commit('setState', { leftList: res.data.list })
  //   }

  //   return res
  // },
}

export const homeStore = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default homeStore
